var _rect, _g, _g2, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSubscription(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.1602,
    y: 16,
    width: 43.78,
    height: 43.78,
    rx: 8,
    fill: "#1E2A10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1881_1929)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.1504,
    cy: 37.7793,
    r: 13.1094,
    fill: "#AAEF77"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1881_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2112 32.4353H15.4968C14.7332 32.4353 14.1143 33.0543 14.1143 33.8178V49.1789C14.1143 49.9425 14.7332 50.5615 15.4968 50.5615H26.2112C26.9747 50.5615 27.5937 49.9425 27.5937 49.1789V33.8178C27.5937 33.0543 26.9747 32.4353 26.2112 32.4353Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2112 32.4353H15.4968C14.7332 32.4353 14.1143 33.0543 14.1143 33.8178V49.1789C14.1143 49.9425 14.7332 50.5615 15.4968 50.5615H26.2112C26.9747 50.5615 27.5937 49.9425 27.5937 49.1789V33.8178C27.5937 33.0543 26.9747 32.4353 26.2112 32.4353Z",
    fill: "url(#paint0_linear_1881_1929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7256 36.6968H24.995",
    stroke: "white",
    strokeWidth: 1.2801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7256 39.8589H22.4476",
    stroke: "white",
    strokeWidth: 1.2801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5783 33.0615H43.8639C43.1004 33.0615 42.4814 33.6805 42.4814 34.444V49.8052C42.4814 50.5687 43.1004 51.1877 43.8639 51.1877H54.5783C55.3419 51.1877 55.9608 50.5687 55.9608 49.8052V34.444C55.9608 33.6805 55.3419 33.0615 54.5783 33.0615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5783 33.0615H43.8639C43.1004 33.0615 42.4814 33.6805 42.4814 34.444V49.8052C42.4814 50.5687 43.1004 51.1877 43.8639 51.1877H54.5783C55.3419 51.1877 55.9608 50.5687 55.9608 49.8052V34.444C55.9608 33.6805 55.3419 33.0615 54.5783 33.0615Z",
    fill: "url(#paint1_linear_1881_1929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0801 37.3101H53.3495",
    stroke: "white",
    strokeWidth: 1.2801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0801 40.4722H50.8021",
    stroke: "white",
    strokeWidth: 1.2801,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8157 23H27.9778C26.8467 23 25.9297 23.7608 25.9297 24.6993V43.1044C25.9297 44.0428 26.8467 44.8036 27.9778 44.8036H41.8157C42.9468 44.8036 43.8638 44.0428 43.8638 43.1044V24.6993C43.8638 23.7608 42.9468 23 41.8157 23Z",
    fill: "#19230E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8157 23H27.9778C26.8467 23 25.9297 23.7608 25.9297 24.6993V43.1044C25.9297 44.0428 26.8467 44.8036 27.9778 44.8036H41.8157C42.9468 44.8036 43.8638 44.0428 43.8638 43.1044V24.6993C43.8638 23.7608 42.9468 23 41.8157 23Z",
    fill: "url(#paint2_linear_1881_1929)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6035 33.0874L32.791 36.2748L40.4715 28.5942",
    stroke: "white",
    strokeWidth: 2.56019,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4186 66.1971L49.2746 64.0524C49.3686 64.0341 49.4579 63.9969 49.5372 63.9432C49.6164 63.8894 49.684 63.8202 49.7357 63.7396C49.7875 63.659 49.8224 63.5688 49.8384 63.4744C49.8544 63.38 49.8511 63.2833 49.8287 63.1901L49.5751 62.0246L50.6409 56.554C50.7978 55.6922 50.7839 54.8079 50.5999 53.9514L48.9529 46.3823C48.9529 46.3823 48.5067 44.3313 46.8387 44.4779C45.1708 44.6245 44.9746 45.6408 44.9746 45.6408C44.9746 45.6408 44.7203 43.9036 43.1876 43.8199C42.7837 43.7722 42.3749 43.8491 42.016 44.0404C41.6571 44.2318 41.3654 44.5284 41.1799 44.8903C41.1195 44.4045 40.8923 43.9546 40.5371 43.6176C40.182 43.2806 39.7208 43.0773 39.2325 43.0424C38.4415 43.0733 37.6942 43.4134 37.1515 43.9897L35.8431 38.7577C35.7565 38.1426 35.432 37.586 34.9393 37.2077C34.4466 36.8295 33.8251 36.6596 33.2085 36.7348C32.6164 36.9226 32.1217 37.3353 31.8308 37.8842C31.5398 38.433 31.4759 39.074 31.6527 39.6695L33.3348 49.3172L31.7134 47.8311C31.1923 47.3567 30.5082 47.1018 29.8038 47.1198C29.0993 47.1377 28.4291 47.427 27.9329 47.9273C27.4601 48.4055 27.1814 49.0421 27.1506 49.7138C27.1198 50.3855 27.3392 51.0448 27.7662 51.5642L30.6512 55.0933C32.4044 58.803 35.0214 62.0383 38.2827 64.5281L38.4508 64.6615L38.6627 65.6353C38.7012 65.8036 38.7984 65.9527 38.937 66.0557C39.0755 66.1587 39.2463 66.2088 39.4186 66.1971Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4186 66.1971L49.2746 64.0524C49.3686 64.0341 49.4579 63.9969 49.5372 63.9432C49.6164 63.8894 49.684 63.8202 49.7357 63.7396C49.7875 63.659 49.8224 63.5688 49.8384 63.4744C49.8544 63.38 49.8511 63.2833 49.8287 63.1901L49.5751 62.0246L50.6409 56.554C50.7978 55.6922 50.7839 54.8079 50.5999 53.9514L48.9529 46.3823C48.9529 46.3823 48.5067 44.3313 46.8387 44.4779C45.1708 44.6245 44.9746 45.6408 44.9746 45.6408C44.9746 45.6408 44.7203 43.9036 43.1876 43.8199C42.7837 43.7722 42.3749 43.8491 42.016 44.0404C41.6571 44.2318 41.3654 44.5284 41.1799 44.8903C41.1195 44.4045 40.8923 43.9546 40.5371 43.6176C40.182 43.2806 39.7208 43.0773 39.2325 43.0424C38.4415 43.0733 37.6942 43.4134 37.1515 43.9897L35.8431 38.7577C35.7565 38.1426 35.432 37.586 34.9393 37.2077C34.4466 36.8295 33.8251 36.6596 33.2085 36.7348C32.6164 36.9226 32.1217 37.3353 31.8308 37.8842C31.5398 38.433 31.4759 39.074 31.6527 39.6695L33.3348 49.3172L31.7134 47.8311C31.1923 47.3567 30.5082 47.1018 29.8038 47.1198C29.0993 47.1377 28.4291 47.427 27.9329 47.9273C27.4601 48.4055 27.1814 49.0421 27.1506 49.7138C27.1198 50.3855 27.3392 51.0448 27.7662 51.5642L30.6512 55.0933C32.4044 58.803 35.0214 62.0383 38.2827 64.5281L38.4508 64.6615L38.6627 65.6353C38.7012 65.8036 38.7984 65.9527 38.937 66.0557C39.0755 66.1587 39.2463 66.2088 39.4186 66.1971Z",
    fill: "url(#paint3_linear_1881_1929)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1881_1929",
    x: 0.0410156,
    y: 0.669922,
    width: 74.2188,
    height: 74.2188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1881_1929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1881_1929",
    x1: 23.0004,
    y1: 41.4984,
    x2: 29.0915,
    y2: 41.4984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1881_1929",
    x1: 51.3676,
    y1: 42.1246,
    x2: 57.4587,
    y2: 42.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1881_1929",
    x1: 37.7526,
    y1: 33.9018,
    x2: 45.8567,
    y2: 33.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#325932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1881_1929",
    x1: 32.1738,
    y1: 31.3415,
    x2: 56.4681,
    y2: 58.1694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348717,
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937045,
    stopColor: "#F8FCF5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1881_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.8463,
    height: 38.2492,
    fill: "white",
    transform: "translate(14.1143 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscription);
export default __webpack_public_path__ + "static/media/icon-subscription.9a061b4a8df9a1ccf0e96fb254ff073b.svg";
export { ForwardRef as ReactComponent };